import axios from 'axios';
// 🔑 Polling for a held upload to land (constants/uploadChecking). check() resolves truthy once the file is stored; the
// promise resolves with that value, or null at the deadline / when cancelled. Every few seconds, for up to five minutes
// (the quarantine sweep runs every minute in production).
export async function pollUntilLanded(check, { everyMs = 4000, timeoutMs = 5 * 60 * 1000, isCancelled = () => false } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, everyMs));
    if (isCancelled()) return null;
    try { const v = await check(); if (v) return v; } catch (_) { /* keep waiting */ }
  }
  return null;
}
export { isUploadChecking, UPLOAD_CHECKING_APPROVED, UPLOAD_CHECKING_COPY } from '../constants/uploadChecking';

// 🔑 ROUND 3 (Jesse, 2026-11-04 — backend utils/uploadFollowUps): a held upload CARRIES the call the screen was about to
// make with its document (attach, answer, cheque month, credit request, account). Registered once; the server runs it
// after the virus check releases the upload, through the same route, as this borrower — or tells staff if it cannot.
// holds: [{ quarantineId, slot }] (slot names where the released ids go; default 'documents'); known: ids already stored.
// Never throws: a failed registration leaves the screen exactly as before (the file still lands; the step is re-doable).
export async function carryFollowUp(api, headers, { kind, params = {}, holds = [], known = {} }) {
  const h = (holds || []).filter((x) => x && Number(x.quarantineId) > 0);
  if (!h.length) return null;
  try {
    const r = await axios.post(`${api}/api/documents/held-follow-up`, { kind, params, holds: h, known }, { headers });
    return (r && r.data) || null;
  } catch (_) { return null; }
}
